export default __webpack_public_path__ + "static/media/AUG2022.9a5273a1.png";